import { render, staticRenderFns } from "./LoanCalculator.vue?vue&type=template&id=133cf1f9&scoped=true&"
import script from "./LoanCalculator.vue?vue&type=script&lang=js&"
export * from "./LoanCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cf1f9",
  null
  
)

export default component.exports